$(document).ready(function () {

  /*_____ Video Play _____*/
	/* $(document).on("click", ".vid_blk button", function () {
		$(this).hide()
		$(this).parents(".vid_blk").find("video").trigger("play")
	}) */
	$(document).on("mouseenter", "#slick-watch .vid_blk", function () {
      $("#slick-watch .vid_blk video").trigger("pause")
      $("#slick-watch .vid_blk button").fadeIn()
      $(this).find("button").fadeOut()
      $(this).find("video").trigger("play")
	});
	$(document).on("click", "#slick-watch .vid_blk", function (event) {
      // Get the targeted element that was clicked
      let targetElement = $(event.target);
      let tagName = targetElement.prop('tagName').toLowerCase();

      if(tagName != 'img'&& tagName != 'a') {
        $("#slick-watch .vid_blk video").trigger("pause")
        $("#slick-watch .vid_blk button").fadeIn()
        $("#watch .popup_block").addClass("active")
        $("#slick-watch-popup .item.slick-center button").fadeOut()
        $("#slick-watch-popup .item.slick-center .vid_blk video").trigger("play").attr("controls", true)
      }
	});
	$(document).on("click", "#slick-watch-popup .slick-arrow", function () {
      $("#slick-watch-popup .vid_blk video").trigger("pause").attr("controls", false)
      $("#slick-watch-popup .vid_blk button").fadeIn()
      $("#slick-watch-popup .item.slick-center button").fadeOut()
      $("#slick-watch-popup .item.slick-center .vid_blk video").trigger("play").attr("controls", true)
	});
	$(document).on("click", "#watch .popup_block .x_btn", function () {
      $("#watch .vid_blk video").trigger("pause").attr("controls", false)
      $("#watch .vid_blk button").fadeIn()
      $("#watch .popup_block").removeClass("active")
	});

	/*
	|----------------------------------------------------------------------
	|		OTHER JAVASCRIPT
	|----------------------------------------------------------------------
	*/
	$("#slick-watch").slick({
		dots: false,
		arrows: true,
		infinite: false,
		speed: 1000,
		slidesToShow: 5,
		slidesToScroll: 4,
        swipeToSlide: true,
		focusOnSelect: true,
		asNavFor: "#slick-watch-popup",
		responsive: [
			{
				breakpoint: 1025,
				settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
				},
			},
			{
				breakpoint: 992,
				settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
				},
			},
			{
				breakpoint: 769,
				settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
				},
			},
			{
				breakpoint: 576,
				settings: {
                  slidesToShow: 1.3,
                  slidesToScroll: 1,
				},
			},
		],
	});
	$("#slick-watch-popup").slick({
		dots: false,
		arrows: true,
		infinite: false,
		speed: 1000,
		slidesToShow: 5,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: 0,
		variableWidth: true,
		draggable: false,
		asNavFor: "#slick-watch",
	});


  
  $('#slick-static-feat').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    pauseOnHover: true,
    cssEase: 'linear',	
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }]
  });

  $('#slick-pro-static-feat').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    pauseOnHover: true,
    cssEase: 'linear',	
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        }
      }]
  });
  
  // Product Slider
  $("#slick-products").slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    swipeToSlide: true,
    autoplaySpeed: 0,
    speed: 600,
    cssEase: "linear",
    prevArrow:
      '<button class="slide-arrow prev-arrow"><i class="far fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><i class="far fa-long-arrow-right"></i></button>',
    slidesToShow: 3.3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2.2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.3,
        },
      },
    ],
  });

  $("#slick-review").slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    swipeToSlide: true,
    speed: 700,
    prevArrow:
      '<button class="slide-arrow prev-arrow"><i class="far fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><i class="far fa-long-arrow-right"></i></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  });

  $("#slick-insta").slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 800,
    cssEase: "linear",
    prevArrow:
      '<button class="slide-arrow prev-arrow"><i class="far fa-long-arrow-left"></i></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow"><i class="far fa-long-arrow-right"></i></button>',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3.3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.4,
        },
      },
    ],
  });

  /*_____ Video _____*/
  $(document).on("click", ".vid_blk .play-vid", function () {
    let sec = $(this).parents("section");
    sec.find(".video_popup").fadeIn();
    let src = sec.find(".video_popup iframe").attr("data-src");
    sec.find(".video_popup iframe").attr("src", src);
  });
  $(document).on("click", ".video_popup .crossBtn", function () {
    $(".video_popup iframe").attr("src", "");
    $(".video_popup").fadeOut();
  });

  // To check If it is in Viewport
  const counters = document.querySelectorAll(".counter");

  counters.forEach((counter) => {
    counter.innerText = "0";
    const updateCounter = () => {
      const target = +counter.getAttribute("data-target");
      const count = +counter.innerText;
      const increment = target / 200;
      if (count < target) {
        counter.innerText = `${Math.ceil(count + increment)}`;
        setTimeout(updateCounter, 1);
      } else counter.innerText = target;
    };
    updateCounter();
  });

  $(".tab-menu li a").on("click", function () {
    var target = $(this).attr("data-rel");
    $(".tab-menu li a").removeClass("active");
    $(this).addClass("active");
    $("#" + target)
      .fadeIn("slow")
      .siblings(".tab-box")
      .hide();
    return false;
  });

  $(".inner-tab-menu li a").on("click", function (e) {
    e.preventDefault();
    $(".content-head").hide();
    $(".inner-tab-menu").hide();
    var target = $(this).attr("data-rel");
    $(".inner-tab-menu li a").removeClass("active");
    $(this).addClass("active");
    $("#" + target)
      .fadeIn("slow")
      .siblings(".inner-tab-box")
      .hide();
    var sectionTop = $("#" + target).offset().top;
    $("html, body").animate({ scrollTop: sectionTop }, "slow");
    return false;
  });

  $(".icon-close").on("click", function (e) {
    e.preventDefault();
    $(".content-head").show();
    $(".inner-tab-menu").show();
    $(".inner-tab-box").hide();
  });

  /*_____ FAQ's _____*/
  $(".faq_blk:nth-child(1)").addClass("active");
  $(document).on("click", ".faq_blk > .title", function () {
    $(".faq_blk")
      .not($(this).parent().toggleClass("active"))
      .removeClass("active");
    $(".faq_blk > .text")
      .not($(this).parent().children(".text").slideToggle())
      .slideUp();
  });

  $(".select-dropdown__button").on("click", function () {
    $(".select-dropdown__list").toggleClass("open");
  });
  $(".select-dropdown__list li a").on("click", function () {
    var itemValue = $(this).data("value");
    console.log(itemValue);
    $(".select-dropdown__button span")
      .text($(this).text())
      .parent()
      .attr("data-value", itemValue);
    $(".select-dropdown__list").toggleClass("open");
  });

  // Feature SLider

  $("#slick-features").slick({
    arrows: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    focusOnSelect: true,
    swipe: false,
    draggable: false,
    swipeToSlide: false,
    asNavFor: "#slick-features-text"
  });
  $("#slick-features-text").slick({
    arrows: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false,
    fade: true,
    swipe: false,
    draggable: false,
    swipeToSlide: false,
    asNavFor: "#slick-features"
  });
  
  let slider_height = $("#slick-features").outerWidth();
  let calc_height = slider_height - (slider_height * 15) / 100;
  $("#slick-features").css("min-height", calc_height);
  
  let current_slider = $("#slick-features .item.slick-current");
  let next1 = current_slider.attr("data-index", "00");
  let next2 = next1.next().attr("data-index", "01");
  let next3 = next2.next().attr("data-index", "02");
  next3.next().attr("data-index", "03");
  
  $(document).on("click", "#slick-features-text .slick-arrow", function () {
    let current_slider = $("#slick-features .item.slick-current");
    let prev1 = current_slider.prev().attr("data-index", "-01");
    let prev2 = prev1.prev().attr("data-index", "-02");
    prev2.prev().attr("data-index", "-03");
    let next1 = current_slider.attr("data-index", "00");
    let next2 = next1.next().attr("data-index", "01");
    let next3 = next2.next().attr("data-index", "02");
    next3.next().attr("data-index", "03");
  });


  if(document.querySelector('.product-info')){
    $(document).scroll(function(){
      if($(this).scrollTop() >= $('.product-info').offset().top + 600) {
        $(".product-quick-add").addClass("is-visible");
      } else {
        $(".product-quick-add").removeClass("is-visible");;
      }
    });
  }

  // $(".header__link-list .relative").mouseenter(function(){
  //   this.setAttribute("open", "");
  // }).mouseleave(function(){
  //  this.removeAttribute("open");
  // });

  
});

var tiles = document.querySelectorAll('.tile');
var wrapper = document.getElementById('effects_wrapper');
if(wrapper) {
  wrapper.addEventListener('change', selected);
}

function selected(e) {
  tiles.forEach((tile) => {
    if(e.target.classList.contains('checkbox')) {
      var item = e.target.parentElement;
    item.classList.toggle('selected');
    };
  });
}